import { CacheKey } from '@libs/vercel';

import Invalid from './invalid.icon.svg';
import Valid from './valid.icon.svg';
import css from './verified.module.scss';

interface Props {
    value: string;
}
export function Verified({ value }: Props) {
    const valid = CacheKey.isValid(value);
    const Icon = valid ? Valid : Invalid;

    return (
        <div className={css.verified}>
            <span className={css.badge}>
                <Icon />
            </span>

            <div>
                <p className={css.title}>{valid ? 'Verified' : 'Invalid'}</p>
                <p className={css.subtitle}>
                    {valid ? 'This cache key is valid and ready to use.' : 'Cache key format is invalid.'}
                </p>
            </div>
        </div>
    );
}
